import PanelItem from './PanelItem'
import ImagePreviewer from "../form/ImagePreviewer"

const ImagePanelItem = (props) => (
    <PanelItem {...props}>
        <ImagePreviewer url={props.url} />
    </PanelItem>
)

export default ImagePanelItem;